import React from 'react';
const Relative = () => {
  return (
    <div className="relative">
      <div className="relative-position">
        <h4>position:relative 相对于自身定位</h4>
        <div className="relative-position-container">
        </div>
      </div>
    </div>
  );
};

export default Relative;
